module.exports = __webpack_public_path__ + "static/media/twitter.c3bebdc3.png";